<template>
    <div v-if="getCartListingVisible">
        <div class="container">
            <div class="row m-3">
                <button v-if="gallery.id !== undefined && !isEmptyCart && gallery.is_sale_in_place"
                        class="btn btn-primary p-3"
                        @click="showCheckoutForm"> Quero estas fotos! Encomendar... <i class="fa fa-arrow-right"></i>
                </button>
                <button v-if="gallery.id !== undefined && !isEmptyCart && !gallery.is_sale_in_place"
                        class="btn btn-primary float-end"
                        @click="showCheckoutForm"> Prosseguir
                    com a Compra <i class="fa fa-arrow-right"></i>
                </button>
            </div>
            <div class="row mt-2">
                <button
                    class="btn btn-link"
                    @click="showGallery"
                >
                    <i class="fa fa-arrow-left"></i> Voltar à Galeria
                </button>
            </div>

            <div class="row">
                <div v-if="isEmptyCart" class="col-12 mt-5 m-auto header-panel">
                    <h4>Ohhh! Não tem imagens no seu carrinho...</h4>
                    <p>
                        Para adicionar imagens ao seu carrinho deve
                        selecioná-las a partir da Galeria
                        <br/>Clique aqui para voltar à galeria.
                    </p>
                </div>
            </div>

            <div class="row mt-4 masonry-grid">
                <div
                    v-for="(row, rowIndex) in getCart"
                    :key="rowIndex"
                    class="col-12 col-md-6 col-lg-4 col-xl-4 mt-2"
                >
                    <div class="card">
                        <div class="w-100 text-center">
                            <img
                                :src="row.image.thumbnail"
                                class="p-2 cart-listing"
                                @load="imgLoaded"
                            />
                        </div>
                        <button
                            class="btn btn-outline remove-photo"
                            type="button"
                            @click="removeFromCart(rowIndex)"
                        >
                            <i class="fa fa-trash"></i>
                        </button>
                        <div class="card-body">
                            <div class="row">
                                <div class="col ml-auto">
                                    <table class="table price-table">
                                        <thead>
                                        <tr>
                                            <th class="col-md-4">Quantidade</th>
                                            <th class="col-md-8 text-center">
                                                Tamanho (cm)
                                            </th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                            v-for="(item, index) in row.sizes" :key="index">
                                            <td>
                                                <select v-model="item.quantity" class="form-select"
                                                        @change="updateQuantity( $event,  row, index)">
                                                    <option value="1">1</option>
                                                    <option value="2"> 2</option>
                                                    <option value="3"> 3</option>
                                                    <option value="4"> 4</option>
                                                    <option value="5"> 5</option>
                                                    <option value="6"> 6</option>
                                                    <option value="7"> 7</option>
                                                    <option value="8"> 8</option>
                                                    <option value="9"> 9</option>
                                                    <option value="10"> 10</option>
                                                </select>
                                            </td>
                                            <td>
                                                <div class="text-center"
                                                     v-if="(gallery.available_sizes !== undefined) && (gallery.available_sizes.length === 1)">
                                                    {{ gallery.available_sizes[0].name }}
                                                </div>
                                                <select
                                                    v-if="gallery.available_sizes !== undefined && gallery.available_sizes.length > 1"
                                                    v-model="item.image_size_id"
                                                    class="form-select"
                                                    @change="updateSize( $event,row, index)">
                                                    <option
                                                        v-for="( size, index ) in gallery.available_sizes" :key="index"
                                                        :value="size.id"
                                                    >
                                                        {{ size.name }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td>
                                                <button
                                                    class="btn btn-outline-seconday remove-photo"
                                                    title="Remover este tamanho"
                                                    type="button"
                                                    @click="
                                                            removeSize(
                                                                row,
                                                                index
                                                            )
                                                        "
                                                >
                                                    <i
                                                        class="fa fa-trash"
                                                    ></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="(gallery.available_sizes !== undefined) && (gallery.available_sizes.length > 1)">
                                            <td colspan="3">
                                                <button
                                                    class="btn btn-secondary w-100"
                                                    type="button"
                                                    @click="addSize(row)"
                                                >
                                                    Adicionar outros
                                                    tamanhos
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td class="text-right" colspan="3" style="background-color: #efefef">
                                                {{ parseDecimalPlaces(row.items_price) }} &euro;
                                            </td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr/>
            <div class="row mb-5 mt-2">
                <div class="col text-center">
                    <button v-if="gallery.id !== undefined && !isEmptyCart && gallery.is_sale_in_place"
                            class="btn btn-primary p-3 "
                            @click="showCheckoutForm"> Quero estas fotos! Encomendar... <i
                        class="fa fa-arrow-right"></i>
                    </button>
                    <button v-if="gallery.id !== undefined && !isEmptyCart && !gallery.is_sale_in_place"
                            class="btn btn-primary float-end"
                            @click="showCheckoutForm"> Prosseguir
                        com a Compra <i class="fa fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import Masonry from "masonry-layout";

export default {
    name: "CartListing",
    props: ["gallery"],
    data() {
        return {
            isVisible: false,
            totalLoaded: 0,
        };
    },
    updated() {
        this.totalLoaded = 0;
    },
    methods: {
        showGallery() {
            this.$store.dispatch("showGallery");
        },
        // remove item from cart
        removeFromCart(index) {
            this.$confirm(
                "Tem a certeza que pretende remover esta imagem?",
                "Remover imagem do carrinho?",
                "question",
                {
                    confirmButtonText: "Sim, remover",
                    cancelButtonText: "Não, não remover",
                }
            ).then(() => {
                this.$store.dispatch("removeImage", index);
            });
        },
        updateQuantity(event, row, index) {
            if (parseFloat(event.target.value) < 0) {
                event.target.value = 0;
            }
            this.$store.dispatch("updateItemQuantity", {
                row,
                index,
                new_quantity: event.target.value,
            });
        },
        updateSize(event, row, index) {
            this.$store.dispatch("updateItemSize", {
                row,
                index: index,
                newSize: event.target.value,
            });
        },
        emptyCart() {
            this.$store.dispatch("emptyCart");
        },
        imgLoaded() {
            this.totalLoaded++;
            if (this.totalLoaded === this.getCart.length) {
                var grid = document.querySelector(".masonry-grid");
                this.msry = new Masonry(grid);
            }
        },
        showCheckoutForm() {
            this.$store.dispatch("showCheckoutForm");
        },
        parseDecimalPlaces(value) {
            return Number(
                Math.round(parseFloat(value + "e" + 2)) + "e-" + 2
            ).toFixed(2);
        },
        addSize(row) {
            this.$store.dispatch("addSizeToRow", row);
        },
        removeSize(row, index) {
            const self = this;
            this.$confirm(
                "Tem a certeza que pretende remover este tamanho?",
                "Remover tamanho?",
                "question",
                {
                    confirmButtonText: "Sim, remover",
                    cancelButtonText: "Não, não remover",
                }
            ).then(() => {
                self.$store.dispatch("removeSizeRow", {
                    image_id: row.image.id,
                    index: index,
                });
            });
        },
    },
    computed: {
        isEmptyCart() {
            return this.getCart.length === 0;
        },
        ...mapGetters([
            "getCart",
            "getCartListingVisible",
            "getTotalPrice",
            "imageSizes",
        ]),
    },
};
</script>
